import { Component, EventEmitter, Output } from '@angular/core';

import { TrackingService } from 'src/app/modules/shared/services/tracking.service';

@Component({
  selector: 'app-profile-dialog-2fa-disable',
  templateUrl: './profile-dialog-2fa-disable.component.html',
  styleUrls: ['./profile-dialog-2fa-disable.component.scss'],
  standalone: false
})
export class ProfileDialog2FADisableComponent {
  @Output() closed = new EventEmitter<boolean>();
  @Output() confimed = new EventEmitter<boolean>();

  constructor(private trackingService: TrackingService) {}

  close(): void {
    this.closed.emit(true);
  }

  switchOff(): void {
    this.trackingService.trackActivity('[Button] Deactivate 2FA - Confirmed');
    this.confimed.emit(true);
    this.close();
  }
}
